import React, { useState } from 'react';
import WalletBar from '../../components/WalletBar';
import HistoryItem from '../../components/HistoryItem';
import Chart from '../../assets/icons/Chart';
import WalletGraph from '../WalletGraph';
import WalletOverlay from '../WalletOverlay';
import { convertDate, groupTransactionsByDate } from '../../utils';
import { useQuery } from '@tanstack/react-query';
import { getWalletTransactions } from '../../api/wallets';

const WalletTab = () => {
  const [activeTab, setActiveTab] = useState(1);

  const { data } = useQuery({
    queryKey: ['wallet-transactions'],
    queryFn: () => getWalletTransactions({ page: 1, limit: 100 }),
    staleTime: 1000 * 30,
  });



  const groupedTransactions = groupTransactionsByDate(
    data?.results || [],
  );

  const hasTransactions = !!(data && data.total);

  return (
    <div className='relative mt-[20px] flex flex-col gap-2'>
      <WalletOverlay />

      <WalletBar active={activeTab} onChange={(value) => setActiveTab(value)} />

      <WalletGraph />

      <span className='text-sm font-medium text-white'>
        {hasTransactions ? 'History:' : 'You do not have any transactions yet.'}
      </span>

      {hasTransactions && (
        <>
          <div className='flex flex-col gap-2'>
            {Object.entries(groupedTransactions).map(([date, transactions]) => (
              <React.Fragment key={date}>
                <span className='text-sm text-green-blue-3'>
                  {convertDate(date).formattedDate}
                </span>

                {transactions.map((item, index) => (
                  <HistoryItem
                    key={index}
                    label={item.description}
                    price={item.amount}
                    type={item.transaction_type}
                    time={convertDate(item.created_at).formattedTime}
                    icon={<Chart />}
                  />
                ))}
              </React.Fragment>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default WalletTab;
